import {wdiCore, WdiInput, WdiModalAppProps, WdiTextArea} from '@/components/WdiControls';
import {WdiModalForm} from '@/components/WdiControls/WdiModalForm';
import {ResponseStatus} from '@/utils/request';
import {Form, message} from 'antd';
import React, {useEffect, useRef, useState} from 'react';
import {ProFormInstance} from '@ant-design/pro-form';
import {WdiInputNumber} from '@/components/WdiControls/WdiInputNumber';
import {FormSpMkt} from "@/services/mkt/sp";


const PaymentDetailEditApp: React.FC<WdiModalAppProps> = (props) => {
  const formRef = useRef<ProFormInstance>();
  const [formSpMktDetail, setFormSpMktDetail] = useState<any>();

  useEffect(() => {
    const detail = props.data.record;
    formRef.current?.setFieldsValue({
      projectMktName: detail.projectMktName,
      ccCodeOrName: wdiCore.String.CodeOrName(detail.ccCode, detail.ccName),
      productBuyNames: detail.productBuyNames,
      ecMktName: detail.ecMktName,
      paymentMethodName: detail.paymentMethodName,
      supplierCodeOrName: wdiCore.String.CodeOrName(detail.supplierCode, detail.supplierName),
      amountNotPaid: wdiCore.Number.AmountToString(detail.amountNotPaid),
      amountOriginal: wdiCore.Number.AmountToString(detail.amountOriginal),
      amountInVat: wdiCore.Number.ToNumber(detail.amountInVat, 2),
      modifyReason: detail.modifyReason,
    });
    setFormSpMktDetail(detail);
  }, [props.data.record]);

  return (
    <>
      <WdiModalForm
        formRef={formRef}
        labelCol={{span: 7}}
        wrapperCol={{span: 12}}
        labelAlign='left'
        layout='horizontal'
        title={props.title}
        visible={props.visible}
        modalProps={{
          onCancel: () => {
            props.onClose?.();
          },
        }}
        onFinish={async (values) => {
          const {amountInVat, modifyReason} = values;
          const response = await FormSpMkt.Buttons.modifyAmount({
            pageTypeId: props.data.formSpMkt.pageTypeId,
            formSpMktDetail: Object.assign({}, {...formSpMktDetail}, {amountInVat, modifyReason}),
          });
          if (response.code !== ResponseStatus.SUCCESS) {
            message.error(response.message);
          } else {
            message.success('保存成功!');
            if (props.onSave) {
              props.onSave({
                code: ResponseStatus.SUCCESS,
                data: Object.assign({}, {...formSpMktDetail}, response.data),
              });
            }
          }
        }}
      >
        <Form.Item name='projectMktName' label='广告项目'>
          <WdiInput readOnly/>
        </Form.Item>
        <Form.Item name='ccCodeOrName' label='成本中心'>
          <WdiInput readOnly/>
        </Form.Item>
        <Form.Item name='productBuyNames' label='产品别'>
          <WdiInput readOnly/>
        </Form.Item>
        <Form.Item name='ecMktName' label='费用项'>
          <WdiInput readOnly/>
        </Form.Item>
        <Form.Item name='paymentMethodName' label='支付方式'>
          <WdiInput readOnly/>
        </Form.Item>
        <Form.Item name='supplierCodeOrName' label='供应商'>
          <WdiInput readOnly/>
        </Form.Item>
        <Form.Item name='amountNotPaid' label='可核销金额'>
          <WdiInput readOnly/>
        </Form.Item>
        <Form.Item name='amountOriginal' label='原核销金额'>
          <WdiInput readOnly/>
        </Form.Item>
        <Form.Item name='amountInVat' label='最终核销金额' rules={[{required: true, message: '最终核销金额不能为空'}]}>
          <WdiInputNumber format='d' digits={2}/>
        </Form.Item>
        <Form.Item name='modifyReason' label='修改原因' rules={[{required: true, message: '修改原因不能为空'}]}>
          <WdiTextArea rows={4} maxLength={250}/>
        </Form.Item>
      </WdiModalForm>
    </>
  );
};
export default PaymentDetailEditApp;
